import React, { Fragment, useEffect, useRef, useState } from 'react';
import '../css/Shipment.css';

const Shipment = (props) => { 
    const [isSticky, setSticky] = useState(false);
    const [boxesInput, setBoxesInput] = useState(props.location.state.message.boxes);
    const [data, setData] = useState(props.location.state.message);
    const [shipments, setShipments] = useState(JSON.parse(localStorage.getItem('data13')));

    //---MOB SCROLL
    const ref = useRef(null); 
    const handleScroll = () => {
        if (ref.current) {
        setSticky(ref.current.getBoundingClientRect().top <= 0);
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
        window.removeEventListener('scroll', () => handleScroll);
        };
    }, []); 
    //---MOB SCROLL
    
    //--NEW DATA AFTER LOAD
    useEffect(() => { 
        setShipments(JSON.parse(localStorage.getItem('data13')))
    }, [props.location.state.shipments]) 
    //--NEW DATA AFTER LOAD

    //--UPDATES SHIPMENT DATA
    useEffect(() => { 
        const found = shipments.find(nnn => nnn.id === props.match.params.id)
        setData(found)
        setBoxesInput(found.boxes)
    }, [props.match.params.id])
    //--UPDATES SHIPMENT DATA

    //--SAVES NEW BOXES INPUT TO LOCALSTORAGE
    const newShipments = shipments.map(p =>
        p.id === props.match.params.id
          ? { ...p, boxes: boxesInput }
          : p
    ); 
    
    const onSaveClick = () => { 
        localStorage.setItem('data13', JSON.stringify(newShipments))
        setShipments(JSON.parse(localStorage.getItem('data13')))
    }
    //--SAVES NEW BOXES INPUT TO LOCALSTORAGE

    const renderCargo = () => {
        if(boxesInput === '') {
            return (
                <div>
                    <div className='shipment-cargoBays'>There is no outgoing cargo for that company</div>
                    <input className='shipment-boxesInput' onChange={e => setBoxesInput(e.target.value)} value={boxesInput}></input>
                    <button onClick={onSaveClick} className='header-actionBtn header-actionBtn--save'>Save</button>
                </div>
            );
        }
        let baysRequired = 1;
        let currentBaySize = 0;
        const orderArray = boxesInput.split(',');
        const countItems = orderArray.length;
        let i;
        for (i = 0; i < countItems; i++) {
            var currentItem = parseFloat( orderArray[i] ); 
            if ( currentBaySize + currentItem > 10 ) {
                baysRequired++
                currentBaySize = currentItem
            } else {
                currentBaySize += currentItem
            }
        }
        return(
            <div>
                <p className='shipment-cargoBays'>Number of required cargo bays: <b>{baysRequired}</b></p>
                <input className='shipment-boxesInput' onChange={e => setBoxesInput(e.target.value)} value={boxesInput}></input>
                <button onClick={onSaveClick} className='header-actionBtn header-actionBtn--save'>Save</button>
            </div>
        );           
    }

    const renderContent = () => {
        return(
            <div>
               <h2 className='shipment-companyName'>{data.name}</h2>
               <p className='shipment-companyEmail'>{data.email}</p>
                {renderCargo()}
            </div>
        )
    }

    if (data) {
        return(
            <Fragment>
                <div className={`sticky-wrapper${isSticky ? ' sticky' : ''}`} ref={ref}>
                    <div className=" shipment-container sticky-inner"> 
                        {renderContent()}     
                    </div>
                </div>
            </Fragment>          
        );    
    }
    return;         
};

export default Shipment;